import React, { useEffect, useRef } from 'react'
import { Route, Redirect, useHistory } from 'react-router-dom'
import propTypes from 'prop-types'
import { useDispatch, useSelector } from 'react-redux'
import Header from '../../components/Mobile/Header'
// import { clearLoginRequest, loginRequestFailed, checkLoginRequest } from '../redux-saga/Admin/Login/Reducer'
// import Header from '../components/Admin/Header'

function PrivateRoute({ component: Component, ...rest }) {
  const history = useHistory()
  const dispatch = useDispatch()
  const { user } = useSelector((state) => state.login)
  const isMounted = useRef(false)
  useEffect(() => {
    // if (isMounted.current) {
    // dispatch(checkLoginRequest())
    // } else {
    //   isMounted.current = true
    // }
  }, [ history?.location?.pathname ])
  // console.log('Here in private components = ', history.location.pathname)
  const authed = !!(localStorage.getItem('jwtToken')
  && localStorage.getItem('user')
  && user)
  // const authed = true
  // console.log('Here in private components = ', history.location.pathname)
  const handleLogout = () => {
    localStorage.clear()
    // dispatch(loginRequestFailed())
    history.push('/user/login')
  }
  return (
    <Route
      { ...rest }
      render={ (props) => (authed ? (
        <>
          <Header />
          <Component { ...props } />
        </>
      ) : (
        <Redirect to={ { pathname: '/user/login' } } />)
      ) }
    />
  )
}

PrivateRoute.propTypes = {
  component: propTypes.func.isRequired,
}

export default PrivateRoute
